module.exports = __webpack_public_path__ + "img/img-3.44e68afa.png";